export default "__VITE_ASSET__905a80b3__"